import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import siteConfig, { formatPrice, readSessionValue } from "../config/siteConfig";
import "../css/paysuccess.css";

function PaySuccess() {
  const location = useLocation();
  let storedOrder = null;
  try {
    storedOrder = JSON.parse(
      readSessionValue(`${siteConfig.brandName}.last-order`)
    );
  } catch {
    storedOrder = null;
  }
  const state = location.state || storedOrder;

  useEffect(() => {
    document.title = `Order confirmed | ${siteConfig.displayName}`;
  }, []);

  if (!state) {
    return (
      <main className="success-page">
        <section className="success-card">
          <p className="eyebrow">NO RECENT ORDER</p>
          <h1>There is no order confirmation to show.</h1>
          <p>Complete checkout to see your confirmation details here.</p>
          <Link className="button" to="/shop">Continue shopping</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="success-page">
      <section className="success-card">
        <div className="success-icon"><FiCheck /></div>
        <p className="eyebrow">ORDER CONFIRMED</p>
        <h1>Thank you for shopping at {siteConfig.displayName}.</h1>
        <p>
          {state.email
            ? `A confirmation has been prepared for ${state.email}.`
            : "Your order confirmation will appear here after checkout."}
        </p>

        <dl>
          <div><dt>Order number</dt><dd>{state.orderNumber}</dd></div>
          <div><dt>Customer</dt><dd>{state.customerName}</dd></div>
          <div><dt>Delivery</dt><dd>{state.shippingMethod === "express" ? "Express delivery" : "Standard delivery"}</dd></div>
          {state.total != null && <div><dt>Total</dt><dd>{formatPrice(state.total)}</dd></div>}
        </dl>

        <div className="success-actions">
          <Link className="button button--outline" to="/contact">Check FAQ</Link>
          <Link className="button" to="/">Back to homepage</Link>
        </div>
      </section>
    </main>
  );
}

export default PaySuccess;
